import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { getTranslate } from 'utility/MapperTranslate'
import { confirmationAlert, showAlert } from 'utility/SweetAlert'

const InteractorWarehouseRequestLinesUpdate = () => {
  const warehouseRequestLinesUpdate = useCallback((body, loading) => {
    const payload = {
      ...body,
    }
    confirmationAlert({
      message: getTranslate('message.confirm_process'),
      icon: 'question',
    }).then((result) => {
      if (result === true) {
        ApiService.jsonRequest('/warehouse/request-lines/update', payload, (response) => {
          loading(false)
          if (response.code === 7200) {
            showAlert({
              icon: 'success',
              message: getTranslate('message.successfully_updated'),
              timer: 2000,
            })
          } else {
            showAlert({
              icon: 'error',
              message: getMessage(response?.msg),
              timer: 2000,
            })
          }
        })
      } else {
        loading(false)
      }
    })
  }, [])
  return { warehouseRequestLinesUpdate }
}

export default InteractorWarehouseRequestLinesUpdate
